import { Button, Form, Input, Select, InputNumber, Checkbox } from 'antd';
import { STATUS_ERROR, STATUS_LOADING, useCallGetApi } from 'api/useCallApi';
import ErrorComponent from 'components/ErrorComponent';
import React, { useEffect, useState } from 'react';

const { Option } = Select;

const ActividadForm = (props) => {
  const [categorias, callCategorias, statusCategorias, errorInfo] =
    useCallGetApi('/categoria/all', {
      defaultValue: [],
    });
  const [tipoIntervalo, setTipoIntervalo] = useState('');

  useEffect(() => {
    callCategorias();
  }, [callCategorias]);

  if (statusCategorias === STATUS_ERROR) {
    return <ErrorComponent message={errorInfo.message} />;
  }

  const handleTipoIntervaloChange = (value) => {
    setTipoIntervalo(value);
  };

  const onFinish = (values) => {
    const { intervalo_repeticion, dias_semana, meses } = values;
    const fechas = [];

    if (tipoIntervalo === 'dias' && dias_semana) {
      dias_semana.forEach((dia) => {
        fechas.push({
          tipo_intervalo: 'dias',
          dia_semana: dia,
          intervalo_repeticion,
        });
      });
    }

    if (tipoIntervalo === 'meses' && meses) {
      meses.forEach((mes) => {
        fechas.push({
          tipo_intervalo: 'meses',
          mes,
          intervalo_repeticion,
        });
      });
    }
  };

  return (
    <Form {...props} onFinish={onFinish}>
      <Form.Item
        label="Título de la Actividad"
        name="title"
        rules={[
          {
            required: true,
            message: 'El título es obligatorio',
          },
        ]}
      >
        <Input placeholder="Ingresar el título" />
      </Form.Item>

      <Form.Item
        label="Actividad"
        name="actividad"
        help="Este ítem es el que se mostrará en el informe final."
        rules={[
          {
            required: true,
            message: 'La actividad es obligatoria',
          },
        ]}
      >
        <Input placeholder="Ingresar la actividad" />
      </Form.Item>

      <Form.Item
        label="Resumen"
        name="resumen"
        rules={[
          {
            required: true,
            message: 'El resumen es obligatorio',
          },
        ]}
      >
        <Input placeholder="Ingresar el resumen" />
      </Form.Item>

      <Form.Item
        label="Categoría de la actividad"
        name="id_categoria"
        rules={[
          {
            required: true,
            message: 'La categoría es obligatoria',
          },
        ]}
      >
        <Select
          placeholder="Categorías"
          showSearch
          optionFilterProp="children"
          popupClassName="uppercase"
          loading={statusCategorias === STATUS_LOADING}
          fieldNames={{
            label: 'nombre',
            value: 'id',
          }}
          options={categorias}
          filterOption={(input, option) => {
            return (option?.nombre ?? '')
              .toLowerCase()
              .includes(input.toLowerCase());
          }}
          filterSort={(optionA, optionB) =>
            (optionA?.nombre ?? '')
              .toLowerCase()
              .localeCompare((optionB?.nombre ?? '').toLowerCase())
          }
        />
      </Form.Item>

      {/*<Form.Item label="Obligatorio" name="obligatorio" valuePropName="checked">*/}
      {/*  <Checkbox>¿Es obligatorio?</Checkbox>*/}
      {/*</Form.Item>*/}

      <Form.Item
        label="Tipo de Intervalo"
        name="tipo_intervalo"
        rules={[
          {
            required: true,
            message: 'El tipo de intervalo es obligatorio',
          },
        ]}
      >
        <Select
          placeholder="Seleccione el tipo de intervalo"
          onChange={handleTipoIntervaloChange}
        >
          <Option value="dias">Días</Option>
          <Option value="semanas">Semanas</Option>
          <Option value="meses">Meses</Option>
          <Option value="años">Años</Option>
        </Select>
      </Form.Item>
      {tipoIntervalo === 'dias' && (
        <Form.Item
          label="Días de la Semana"
          name="dias_semana"
          rules={[
            {
              required: true,
              message: 'Seleccione al menos un día de la semana',
            },
          ]}
        >
          <Select mode="multiple" placeholder="Seleccione días de la semana">
            <Option value={0}>Domingo</Option>
            <Option value={1}>Lunes</Option>
            <Option value={2}>Martes</Option>
            <Option value={3}>Miércoles</Option>
            <Option value={4}>Jueves</Option>
            <Option value={5}>Viernes</Option>
            <Option value={6}>Sábado</Option>
          </Select>
        </Form.Item>
      )}

      {tipoIntervalo === 'meses' && (
        <Form.Item
          label="Meses del Año"
          name="meses"
          rules={[
            {
              required: true,
              message: 'Seleccione al menos un mes del año',
            },
          ]}
        >
          <Select mode="multiple" placeholder="Seleccione meses">
            <Option value={1}>Enero</Option>
            <Option value={2}>Febrero</Option>
            <Option value={3}>Marzo</Option>
            <Option value={4}>Abril</Option>
            <Option value={5}>Mayo</Option>
            <Option value={6}>Junio</Option>
            <Option value={7}>Julio</Option>
            <Option value={8}>Agosto</Option>
            <Option value={9}>Septiembre</Option>
            <Option value={10}>Octubre</Option>
            <Option value={11}>Noviembre</Option>
            <Option value={12}>Diciembre</Option>
          </Select>
        </Form.Item>
      )}

      <Form.Item
        label="Es Repetitiva"
        name="es_repetitiva"
        valuePropName="checked"
      >
        <Checkbox>¿Es repetitiva?</Checkbox>
      </Form.Item>

      <Form.Item>
        <Button block type="primary" htmlType="submit">
          Guardar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ActividadForm;
